// // src/components/settings/SecuritySection.jsx
// import { useState } from 'react';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../hooks/useAuth';
// import SettingsCard from './ui/SettingsCard';
// import s from './section.module.css';
// import ds from './DangerModal.module.css';
// import {
//   useChangePasswordMutation,
//   useDeactivateAccountMutation,
//   useDeleteAccountMutation,
//   useReactivateAccountMutation,
// } from '../../store/api/authApi';

// // 
// // Danger confirmation modal
// // 
// function DangerModal({ title, message, confirmLabel, onConfirm, onClose, isLoading, requireTyping, children }) {
//   const [typed, setTyped] = useState('');
//   const ready = !requireTyping || typed === 'DELETE';

//   return (
//     <div className={ds.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
//       <div className={ds.modal} role="dialog" aria-modal="true">
//         <div className={ds.header}>
//           <span className={ds.icon}>{requireTyping ? '' : ''}</span>
//           <h3 className={ds.title}>{title}</h3>
//           <button className={ds.closeX} onClick={onClose} disabled={isLoading}></button>
//         </div>

//         <p className={ds.message}>{message}</p>

//         {children}

//         {requireTyping && (
//           <div className={s.field} style={{ marginTop: 12 }}>
//             <label className={s.label}>Type DELETE to confirm</label>
//             <input
//               className={s.input}
//               placeholder="DELETE"
//               value={typed}
//               onChange={e => setTyped(e.target.value)}
//               autoComplete="off"
//             />
//           </div>
//         )}

//         <div className={ds.actions}>
//           <button className={ds.cancelBtn} onClick={onClose} disabled={isLoading}>
//             Cancel
//           </button>
//           <button
//             className={requireTyping ? ds.dangerBtn : ds.warnBtn}
//             onClick={onConfirm}
//             disabled={!ready || isLoading}
//           >
//             {isLoading ? 'Please wait...' : confirmLabel}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // 
// // Action row inside a card
// // 
// function ActionRow({ label, sublabel, btnLabel, variant = 'outline', onClick }) {
//   return (
//     <div className={s.actionRow}>
//       <div className={s.actionInfo}>
//         <div className={s.actionLabel}>{label}</div>
//         {sublabel && <div className={s.actionSub}>{sublabel}</div>}
//       </div>
//       <button
//         className={variant === 'danger' ? s.btnDanger : s.btnOutline}
//         onClick={onClick}
//       >
//         {btnLabel}
//       </button>
//     </div>
//   );
// }

// // 
// // Main component
// // 
// export default function SecuritySection() {
//   const navigate  = useNavigate();
//   const { logout, user } = useAuth();

//   //  Change password 
//   const [showPwForm, setShowPwForm] = useState(false);
//   const [pwForm, setPwForm]         = useState({ current: '', newPw: '', confirm: '' });
//   const [changePassword, { isLoading: isPwLoading }] = useChangePasswordMutation();

//   //  Modals 
//   const [modal, setModal] = useState(null); // 'deactivate' | 'delete'

//   //  Reactivate (shown when account is deactivated) 
//   const [showReactivate, setShowReactivate]     = useState(false);
//   const [reactivateForm, setReactivateForm]     = useState({ email: '', password: '' });
//   const [reactivate, { isLoading: isReactivating }] = useReactivateAccountMutation();

//   const [deactivate,    { isLoading: isDeactivating }] = useDeactivateAccountMutation();
//   const [deleteAccount, { isLoading: isDeleting }]     = useDeleteAccountMutation();

//   //  Handlers 
//   const handleChangePassword = async () => {
//     const { current, newPw, confirm } = pwForm;
//     if (!current || !newPw || !confirm) { toast.error('Please fill all fields.'); return; }
//     if (newPw !== confirm)              { toast.error('New passwords do not match.'); return; }
//     if (newPw.length < 8)              { toast.error('Password must be at least 8 characters.'); return; }
//     if (newPw === current)             { toast.error('New password must be different from current.'); return; }

//     try {
//       await changePassword({ currentPassword: current, newPassword: newPw }).unwrap();
//       toast.success('Password changed successfully!');
//       setPwForm({ current: '', newPw: '', confirm: '' });
//       setShowPwForm(false);
//     } catch (err) {
//       toast.error(err?.data?.message || err?.data || 'Incorrect current password.');
//     }
//   };

//   const handleDeactivate = async () => {
//     try {
//       await deactivate().unwrap();
//       toast.info('Account deactivated. You can reactivate anytime by logging in.');
//       logout();
//       navigate('/login');
//     } catch (err) {
//       toast.error(err?.data?.message || 'Failed to deactivate account.');
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       await deleteAccount().unwrap();
//       toast.info('Account permanently deleted.');
//       logout();
//       navigate('/');
//     } catch (err) {
//       toast.error(err?.data?.message || 'Failed to delete account.');
//     }
//   };

//   const handleReactivate = async () => {
//     const { email, password } = reactivateForm;
//     if (!email || !password) { toast.error('Enter your email and password.'); return; }
//     try {
//       const res = await reactivate({ email, password }).unwrap();
//       toast.success('Account reactivated successfully!');
//       // Re-login with the returned token
//       if (res?.Token) {
//         localStorage.setItem('authToken', res.Token);
//         localStorage.setItem('userId', res.Id || res.userId || '');
//         localStorage.setItem('profileComplete', res.ProfileCompleted ? 'true' : 'false');
//         navigate('/home');
//       }
//       setShowReactivate(false);
//     } catch (err) {
//       toast.error(err?.data?.message || 'Could not reactivate. Check your credentials.');
//     }
//   };

//   // 
//   return (
//     <>
//       {/*  Change Password  */}
//       <SettingsCard
//         title="Password & Security"
//         subtitle="Update your password regularly to keep your account safe."
//       >
//         {!showPwForm ? (
//           <ActionRow
//             label="Change Password"
//             sublabel="Last updated: unknown. We recommend changing it every 3 months."
//             btnLabel="Change Password"
//             onClick={() => setShowPwForm(true)}
//           />
//         ) : (
//           <div className={s.padded}>
//             <div className={s.field}>
//               <label className={s.label}>Current Password</label>
//               <input
//                 type="password"
//                 className={s.input}
//                 placeholder="Enter your current password"
//                 value={pwForm.current}
//                 onChange={e => setPwForm(p => ({ ...p, current: e.target.value }))}
//               />
//             </div>

//             <div className={s.fieldRow}>
//               <div className={s.field}>
//                 <label className={s.label}>New Password</label>
//                 <input
//                   type="password"
//                   className={s.input}
//                   placeholder="Min. 8 characters"
//                   value={pwForm.newPw}
//                   onChange={e => setPwForm(p => ({ ...p, newPw: e.target.value }))}
//                 />
//               </div>
//               <div className={s.field}>
//                 <label className={s.label}>Confirm New Password</label>
//                 <input
//                   type="password"
//                   className={s.input}
//                   placeholder="Repeat new password"
//                   value={pwForm.confirm}
//                   onChange={e => setPwForm(p => ({ ...p, confirm: e.target.value }))}
//                 />
//               </div>
//             </div>

//             {/* Password strength hint */}
//             {pwForm.newPw.length > 0 && (
//               <p style={{ fontSize:'0.76rem', color: pwForm.newPw.length >= 8 ? '#1d9e75' : '#e07b1e', margin:'0 0 12px' }}>
//                 {pwForm.newPw.length >= 8 ? ' Strong enough' : `${8 - pwForm.newPw.length} more characters needed`}
//               </p>
//             )}

//             <div className={s.btnRow}>
//               <button className={s.btnPrimary} onClick={handleChangePassword} disabled={isPwLoading}>
//                 {isPwLoading ? 'Updating...' : 'Update Password'}
//               </button>
//               <button className={s.btnOutline} onClick={() => { setShowPwForm(false); setPwForm({ current:'', newPw:'', confirm:'' }); }}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </SettingsCard>

//       {/*  Account Actions  */}
//       <SettingsCard
//         title="Account Management"
//         subtitle="Manage your account status."
//       >
//         <ActionRow
//           label="Deactivate Account"
//           sublabel="Temporarily hide your profile. You can reactivate anytime by logging in again."
//           btnLabel="Deactivate"
//           variant="outline"
//           onClick={() => setModal('deactivate')}
//         />

//         <div className={s.divider} />

//         <ActionRow
//           label="Reactivate Account"
//           sublabel="Already deactivated? Re-enter your credentials to bring your account back."
//           btnLabel="Reactivate"
//           variant="outline"
//           onClick={() => setShowReactivate(true)}
//         />

//         <div className={s.divider} />

//         <ActionRow
//           label="Delete Account Permanently"
//           sublabel="All your posts, messages, and connections will be erased forever. This cannot be undone."
//           btnLabel="Delete Account"
//           variant="danger"
//           onClick={() => setModal('delete')}
//         />
//       </SettingsCard>

//       {/*  Deactivate Modal  */}
//       {modal === 'deactivate' && (
//         <DangerModal
//           title="Deactivate Your Account"
//           message="Your profile will be hidden from everyone. Your data is kept safe and you can reactivate anytime by logging in."
//           confirmLabel="Yes, Deactivate"
//           onConfirm={handleDeactivate}
//           onClose={() => setModal(null)}
//           isLoading={isDeactivating}
//           requireTyping={false}
//         />
//       )}

//       {/*  Delete Modal  */}
//       {modal === 'delete' && (
//         <DangerModal
//           title="Permanently Delete Account"
//           message="This will erase your account, all posts, messages, and connections forever. You cannot undo this action."
//           confirmLabel="Permanently Delete"
//           onConfirm={handleDelete}
//           onClose={() => setModal(null)}
//           isLoading={isDeleting}
//           requireTyping={true}
//         />
//       )}

//       {/*  Reactivate Modal  */}
//       {showReactivate && (
//         <DangerModal
//           title="Reactivate Account"
//           message="Enter the email and password of the deactivated account to bring it back."
//           confirmLabel="Reactivate"
//           onConfirm={handleReactivate}
//           onClose={() => setShowReactivate(false)}
//           isLoading={isReactivating}
//           requireTyping={false}
//         >
//           <div className={s.field}>
//             <label className={s.label}>Email</label>
//             <input
//               type="email"
//               className={s.input}
//               placeholder="your@email.com"
//               value={reactivateForm.email}
//               onChange={e => setReactivateForm(p => ({ ...p, email: e.target.value }))}
//             />
//           </div>
//           <div className={s.field} style={{ marginTop: 10 }}>
//             <label className={s.label}>Password</label>
//             <input
//               type="password"
//               className={s.input}
//               placeholder="Your password"
//               value={reactivateForm.password}
//               onChange={e => setReactivateForm(p => ({ ...p, password: e.target.value }))}
//             />
//           </div>
//         </DangerModal>
//       )}
//     </>
//   );
// }


import SettingsCard from "./ui/SettingsCard";
import ChangePassword from "./ChangePassword";
import DeactivateAccount from "./DeactivateAccount";
import DeleteAccount from "./DeleteAccount";

export default function SecuritySection() {
  return (
    <>
      {/* ── Change Password ── */}
      <SettingsCard
        title="Password"
        subtitle="Keep your account secure with a strong password."
      >
        <ChangePassword />
      </SettingsCard>

      {/* ── Danger Zone ── */}
      <SettingsCard
        title="Danger Zone"
        subtitle="These actions affect your entire account and cannot be easily reversed."
      >
        <DeactivateAccount />
        <DeleteAccount />
      </SettingsCard>
    </>
  );
}


